
import * as z from "zod";

export const practiceAreas = [
  { label: "Corporate Law", value: "corporate" },
  { label: "Litigation", value: "litigation" },
  { label: "Real Estate", value: "real_estate" },
  { label: "Intellectual Property", value: "ip" },
  { label: "Family Law", value: "family" },
  { label: "Criminal Law", value: "criminal" },
  { label: "Immigration", value: "immigration" },
  { label: "Employment Law", value: "employment" },
  { label: "Tax Law", value: "tax" },
  { label: "Environmental Law", value: "environmental" },
  { label: "Healthcare", value: "healthcare" },
  { label: "Other", value: "other" }
];

export const roleOptions = [
  { label: "Attorney/Partner", value: "attorney_partner" },
  { label: "Associate", value: "associate" },
  { label: "Legal Operations", value: "legal_ops" },
  { label: "IT/Technology", value: "it_tech" },
  { label: "Administration", value: "admin" },
  { label: "C-Suite", value: "c_suite" },
  { label: "Other", value: "other" }
];

export const customSolutionsFormSchema = z.object({
  firstName: z.string().min(1, { message: "First name is required" }),
  lastName: z.string().min(1, { message: "Last name is required" }),
  email: z
    .string()
    .email({ message: "Please enter a valid work email address" })
    .min(1, { message: "Email is required" }),
  company: z.string().min(1, { message: "Company name is required" }),
  role: z.string({
    required_error: "Please select your role"
  }).min(1, { message: "Please select your role" }),
  practiceAreas: z
    .array(z.string())
    .min(1, { message: "Please select at least one practice area" }),
  challenges: z
    .string()
    .max(500, { message: "Please limit your response to 500 characters" })
    .optional(),
  goals: z
    .string()
    .max(500, { message: "Please limit your response to 500 characters" })
    .optional(),
  consent: z.boolean().default(false)
});

export type CustomSolutionsFormValues = z.infer<typeof customSolutionsFormSchema>;
